import React, { useEffect } from 'react';
import Image from 'next/image';
import styled from 'styled-components';
import useSWR from 'swr';
import { Box } from '../../../components/Flex';
import GraphQLErrorText from '../../../components/GraphQLErrorText';
import GuidesBotList from '../../../components/guides/GuidesBotList';
import Loading from '../../../components/Loading';
import { HeadingOne, Subheading } from '../../../components/Text';
import useAuthOrRedirect from '../../../hooks/useAuthOrRedirect';
import { WHITE_LABEL_LOGO } from '../../../lib/white-label';
import { TranscriptsEmptyView } from './bot/[id]';
import { analytics } from '../../../lib/analytics';

const AvailableGuidesWrapper = styled.div``;

const AvailableGuides = () => {
  const {
    data: channels,
    error: err,
    isValidating,
    mutate,
  } = useSWR('/discord-transcripts-mirror/available', {
    revalidateOnFocus: false,
  });

  useEffect(() => {
    analytics.page('Rental Guides');
  }, []);

  if (!useAuthOrRedirect()) return null;
  if (isValidating || (!err && !channels)) return <Loading />;
  if (err) return <GraphQLErrorText error={err} />;

  return (
    <AvailableGuidesWrapper>
      <HeadingOne>Guides</HeadingOne>
      <Subheading>All rented bot guides.</Subheading>
      <Box height={20} />
      {channels.length == 0 ? (
        <TranscriptsEmptyView>
          <Image alt="" width={200} height={200} src={WHITE_LABEL_LOGO} />
          <h1>
            No orders exist, once you place an order with tidal rentals your
            bot's information will be here.
          </h1>
        </TranscriptsEmptyView>
      ) : (
        <GuidesBotList data={channels} error={err} loading={isValidating} />
      )}
    </AvailableGuidesWrapper>
  );
};

export default AvailableGuides;
